import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { FloatLabel } from 'primereact/floatlabel';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { propTypes } from 'react-bootstrap/esm/Image';


export default function ProductTypeCombo(props) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState(props.value);

    useEffect(() => {
    
        var list = util.getAllProductTypes();
        setItems(list);
        if(props.value)
            if(props.value != null)
                for(var i=0;i<list.length;i++)
                    if(props.value.id == list[i].id) setItem({...list[i]});
    
    }, []);


    const getItem = function(items, id){
        if(items == null) return null;
        for(var i=0;i<items.length;i++){
            if(items[i].product.id == id) return items[i];
        }
        return null;
    }

    const onItemChanged = function (ii){
        if(!ii) ii = null;
        if(props.onChange){
            props.onChange(ii);
        }
    }


    return(
        <>
        {
            <>
            <Row style={{marginTop:"20px"}}>
                <Col>
                    <div className="card flex justify-content-center">
                        <FloatLabel className="w-full md:w-14rem">
                            <Dropdown inputId="cmb" value={item} onChange={(e) => {setItem(e.value); onItemChanged(e.value);}} options={items} optionLabel="title" className="w-full rtl-dropdown" 
                             checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={loading} scrollHeight="350px"    
                            />
                            <label htmlFor="cmb">نوع محصول</label>
                        </FloatLabel>
                    </div>
                    
                </Col>
            </Row>
            </>
        }
        </>
    )
}